import { render, staticRenderFns } from "./CooperationListComponent.vue?vue&type=template&id=0b6771cf&scoped=true&"
import script from "./CooperationListComponent.vue?vue&type=script&lang=js&"
export * from "./CooperationListComponent.vue?vue&type=script&lang=js&"
import style0 from "./CooperationListComponent.vue?vue&type=style&index=0&id=0b6771cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6771cf",
  null
  
)

export default component.exports